module.exports = __webpack_public_path__ + "assets/person-xs-white-29077c2ec121772b1ea73a40a5b0e198.svg";